import { FIREFEST_BUILDINGS_DEFAULT_LIMIT } from "@/config/constants";
import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import { EventUpgradeIds } from "../config/upgrades";
import EventTileEntity from "../EventTileEntity";
class FireFestivalPyreBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.FIREFEST;

	public static readonly frameName = FrameName.FIRE_FESTIVAL_PYRE;

	public buildingLimit =
		FIREFEST_BUILDINGS_DEFAULT_LIMIT +
		getUpgradeCurrentReplaceValueById(
			EventUpgradeIds.ff_kindling_of_passion,
		) +
		getUpgradeCurrentReplaceValueById(EventUpgradeIds.ff_kindling_of_hope);
}

export default FireFestivalPyreBuildingTileEntity;
